<template>
	<!-- header -->
	<header id="header">
		<div class="hInner header_aiorder header_aiorder_view subHeader">
			<div class="logoWrap">
				<div class="logo"><router-link to="#"></router-link></div>
				<div class="hLine"></div>
				<div class="hName">AI 의뢰서 상세 [접수번호 : {{ items.aiorder_no }}]</div>
			</div>
			<div class="hRight">
				<ul class="subBtn">
					<li><button type="button" class="save_btn" id="aSaveBtn"
							@click="goto_url(`/aiorder_view/${items.id}`)">수정취소</button></li>
				</ul>
				<div class="order_status select">
					<div class="aTit">제작상태</div>
					<select class="progress_status" :class="items.order_status" :value="items.order_status" disabled>
						<option value="ords1" data-bg="#EEFFDD" data-color="#449f25" style="color: rgb(68, 159, 37)">의뢰서
							접수</option>
						<option value="ords2" data-bg="#E3FAF8" data-color="#1E8AD8" style="color: rgb(30, 138, 216)">
							의뢰서 확인</option>
						<option value="ords3" data-bg="#f3f3f3" data-color="#666666" style="color: rgb(102, 102, 102)">
							출고 완료</option>
						<option value="ords4" data-bg="#ffffff" data-color="#e76150" style="color: rgb(231, 97, 80)">
							주문 취소</option>
					</select>
				</div>
			</div>
			<button type="button" class="popup_close" @click="commonjs.winClose()"></button>
		</div>
	</header>

	<div id="ocr_loading">의뢰서 이미지를 인식중입니다.</div>

	<section id="ai_order">
		<div class="content aiorder_input aiorder_edit">
			<div class="contIn">

				<form ref="form_aiorder_update" id="form_aiorder_update" :action="`${SERVER_URL}/api/app/aiorder`"
					@submit.prevent="form_aiorder_update_submit()" method="post" enctype="multipart/form-data"
					autocomplete="off">
					<input type="hidden" name="mode" value="update">
					<input type="hidden" name="aiorder_id" :value="items.id">
					<input type="hidden" name="aiorder_no" :value="items.aiorder_no">
					<input type="hidden" v-model="form.prosthesis_cnt">
					<input type="hidden" v-model="form.remake_cnt">
					<input type="hidden" v-model="form.order_status">
					<input type="hidden" name="methods" value="Upload">
					<input type="hidden" name="hos_id"
						:value="orderJsonData.hospital_mb_id ? orderJsonData.hospital_mb_id : (globaljs.acc_type === 'lab') ? partner.mb_boss_id : globaljs.mb_boss_id">
					<input type="hidden" name="lab_id" id="lab_id"
						:value="orderJsonData.lab_mb_id ? orderJsonData.lab_mb_id : (globaljs.acc_type === 'lab') ? globaljs.mb_boss_id : partner.mb_boss_id">
					<input type="hidden" name="beforeHope" :value="orderJsonData.completeHopeDate">
					<input type="hidden" v-model="form.deleted_file_id">

					<div class="ai_cont ai_cont1">
						<div class="boardTit">1. {{ other_type }} 선택
						</div>
						<div class="boardSubTit">※ 변경이 필요할 경우, 주문 취소 후 재접수가 필요합니다.</div>

						<ul class="match_list choiced">
							<li class="tableItem" data-show="Y">
								<div class="match_img">
									<img v-if="partner.mb_icon" :src="`${SERVER_URL}/images/member/${partner.mb_icon}`"
										style="max-width:100%;">
									<img v-else src="/img/common/profile_ex.png" style="max-width:100%;">
								</div>

								<div class="match_info">
									<p class="match_tit">{{ partner.mb_nick }}</p>
									<p class="match_txt">{{ partner.mb_busi_addr }}</p>
									<p class="match_txt">{{ partner.mb_tel }}&nbsp;/&nbsp;{{ partner.mb_hp }}</p>
								</div>
							</li>
						</ul>
					</div>

					<div class="ai_cont ai_cont2">
						<div class="boardTitWrap boardTitWrap1">
							<div class="boardTit">2. 기공의뢰서 작성</div>
						</div>
						<div class="ai_uploadBtnWrap ai_upload1" :class="{ 'disabled': form.request_doc }">
							<div class="aiFile">
								<div class="aiFile_inner">
									<ul class="aiFileList" id="doc">
										<li v-show="form.request_doc" class="uploaded">
											<div class="aiFileName">
												<span class="icon_filebtn_gray"></span> <b>{{ form.request_doc?.file_origin_name ? form.request_doc?.file_origin_name : form.request_doc?.name }}</b>
												<div class="fileDelete" @click="removeDoc($event)" :data-file_id="form.request_doc?.id">삭제</div>
											</div>
										</li>
										<li v-show="!form.request_doc" class="aiFile_no">업로드된 의뢰서가 없습니다.</li>
									</ul>
									<div class="aiFile_btnWrap">
										<input type="file" ref="requestDoc" id="request_doc" style="display:none;"
											@change="addDoc($event)" accept="image/jpeg, image/png">
										<input type="file" id="old_doc" style="display:none;">
										<div class="aiFile_btn" :class="{ 'disabled': form.request_doc }"
											@click="add_doc_click()"><span class="icon_filebtn"></span>의뢰서 업로드</div>
									</div>

									<!-- <div>
										<img :src="preview" alt="" style="max-width:100%;" />
									</div> -->

								</div>
							</div>
						</div>

						<div class="directInput">
							<div class="form-row">
								<div class="form-group required w25">
									<label for="patientNameInput" class="form-label required">환자명</label>
									<input type="text" class="form-control" id="patientNameInput" v-model="form.patientName" required="">
								</div>
								<div class="form-group w25">
									<label for="patientAge" class="form-label">나이</label>
									<input type="text" data-type="number" class="form-control" id="patientAge" v-model="form.patientAge" maxlength="3"
										@input="handleMaxLengthCheck">
								</div>
								<div class="form-group w25">
									<label for="patientGenderInput" class="form-label">성별</label>
									<select class="form-control" id="patientGenderInput" v-model="form.patientGender">
										<option value="">선택</option>
										<option value="남">남</option>
										<option value="여">여</option>
									</select>
								</div>
								<!-- 240826 수정일때는 감염성 질환 필수선택 -->
								<div class="form-group required w25">
									<label for="infectionInput" class="form-label required">감염성질환</label>
									<select class="form-control" id="infectionInput" v-model="form.infection" required="">
										<option value="">선택</option>
										<option value="Y">Y</option>
										<option value="N">N</option>
									</select>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group w50">
									<label for="hospitalNameInput" class="form-label">치과명</label>
									<input type="text" class="form-control" id="hospitalNameInput" v-model="form.hospitalName">
								</div>
								<div class="form-group w25">
									<label for="hospitalName2Input" class="form-label">담당자</label>
									<input type="text" class="form-control" id="hospitalName2Input" v-model="form.hospitalName2">
								</div>
								<div class="form-group w25">
									<label for="chartNumInput" class="form-label">차트번호</label>
									<input type="text" class="form-control" id="chartNumInput" v-model="form.chartNum">
								</div>
							</div>
							<div class="form-row">
								<div class="form-group w25">
									<label for="labNameInput" class="form-label">기공소명</label>
									<input type="text" class="form-control" id="labNameInput" v-model="form.labName">
								</div>
								<div class="form-group w25">
									<label for="chartDateInput" class="form-label">차트 접수일</label>
									<input type="date" class="form-control" id="chartDateInput" v-model="form.chartDate">
								</div>
								<div class="form-group required w25">
									<label for="registerDateInput" class="form-label required">주문일</label>
									<input type="date" class="form-control" id="registerDateInput" v-model="form.registerDate" required="" readonly="">
								</div>
								<div class="form-group required w25">
									<label for="completeHopeDateInput" class="form-label required">희망완료일</label>
									<input type="date" class="form-control" id="completeHopeDateInput" v-model="form.completeHopeDate" required="">
								</div>
							</div>
						</div>
					</div>

					<div class="ai_cont ai_cont3">
						<div class="boardTitWrap">
							<div class="boardTit">발송물품</div>
							<div class="scanChk">
								<input type="checkbox" v-model="form.scan" id="scan" true-value="scan" false-value="">
								<label for="scan"><span>구강스캔</span></label>
							</div>
						</div>
						<div id="ai_prosthesis">
							<div class="form-row">
								<div class="form-group">
									<label for="prosthesisInput1" class="form-label">상악Tray</label>
									<input type="text" data-type="number" class="form-control" id="prosthesisInput1" v-model="form.prosthesis1" maxlength="3"
										@input="handleMaxLengthCheck" @blur="handleValueCheck">
								</div>
								<div class="form-group">
									<label for="prosthesisInput2" class="form-label">하악Tray</label>
									<input type="text" data-type="number" class="form-control" id="prosthesisInput2" v-model="form.prosthesis2" maxlength="3"
										@input="handleMaxLengthCheck" @blur="handleValueCheck">
								</div>
								<div class="form-group">
									<label for="prosthesisInput3" class="form-label">Bite Tray</label>
									<input type="text" data-type="number" class="form-control" id="prosthesisInput3" v-model="form.prosthesis3" maxlength="3"
										@input="handleMaxLengthCheck" @blur="handleValueCheck">
								</div>
								<div class="form-group">
									<label for="prosthesisInput4" class="form-label">Bite</label>
									<input type="text" data-type="number" class="form-control" id="prosthesisInput4" v-model="form.prosthesis4" maxlength="3"
										@input="handleMaxLengthCheck" @blur="handleValueCheck">
								</div>
								<div class="form-group">
									<label for="prosthesisInput5" class="form-label">상악모델</label>
									<input type="text" data-type="number" class="form-control" id="prosthesisInput5" v-model="form.prosthesis5" maxlength="3"
										@input="handleMaxLengthCheck" @blur="handleValueCheck">
								</div>
							</div>
							<div class="form-row">
								<div class="form-group">
									<label for="prosthesisInput6" class="form-label">하악모델</label>
									<input type="text" data-type="number" class="form-control" id="prosthesisInput6" v-model="form.prosthesis6" maxlength="3"
										@input="handleMaxLengthCheck" @blur="handleValueCheck">
								</div>
								<div class="form-group">
									<label for="prosthesisInput7" class="form-label">Analog</label>
									<input type="text" data-type="number" class="form-control" id="prosthesisInput7" v-model="form.prosthesis7" maxlength="3"
										@input="handleMaxLengthCheck" @blur="handleValueCheck">
								</div>
								<div class="form-group">
									<label for="prosthesisInput8" class="form-label">코핑</label>
									<input type="text" data-type="number" class="form-control" id="prosthesisInput8" v-model="form.prosthesis8" maxlength="3"
										@input="handleMaxLengthCheck" @blur="handleValueCheck">
								</div>
								<div class="form-group">
									<label for="prosthesisInput9" class="form-label">이전모델</label>
									<input type="text" data-type="number" class="form-control" id="prosthesisInput9" v-model="form.prosthesis9" maxlength="3"
										@input="handleMaxLengthCheck" @blur="handleValueCheck">
								</div>
								<div class="form-group">
									<label for="prosthesisInput10" class="form-label">이전보철</label>
									<input type="text" data-type="number" class="form-control" id="prosthesisInput10" v-model="form.prosthesis10" maxlength="3"
										@input="handleMaxLengthCheck" @blur="handleValueCheck">
								</div>
							</div>
						</div>

						<div id="ai_prosthesis_detail">
							<aiorder_template v-if="other_id" v-model="arrayData" :other_id="other_id" :isNew="false" @update-remake-count="updateRemakeCount" @update-source="updateSource" />
						</div>
					</div>

					<div class="ai_cont ai_cont4">
						<div class="boardTitWrap">
							<div class="boardTit">3. [선택] 첨부파일</div>
							<div class="boardSubTit">※ 최대 5개까지, 한번에 여러 파일도 선택가능합니다.</div>
						</div>
						<div class="ai_uploadBtnWrap ai_upload2" :class="{ 'disabled': form.attach_file.length > 4 }">
							<div class="aiFile">
								<div class="aiFile_inner">
									<ul class="aiFileList" id="file">
										<li v-for="(file, index) in form.attach_file" :key="index"
											v-show="form.attach_file" class="uploaded">
											<div class="aiFileName">
												<span class="icon_filebtn_gray"></span><b>{{ file?.file_origin_name ? file?.file_origin_name : file?.name }}</b>
												<div class="fileDelete" @click="removeFile($event, index)" :data-file_id="file?.id">삭제</div>
											</div>
										</li>
										<li v-show="!form.attach_file" class="aiFile_no">업로드된 파일이 없습니다.</li>
									</ul>
									<div class="aiFile_btnWrap">
										<input type="file" ref="fileInput" id="attach_file" style="display:none;"
											@change="addFile($event)"
											accept="image/gif, image/jpeg, image/png, application/pdf">
										<input type="file" id="old_file" style="display:none;">
										<div class="aiFile_btn" :class="{ 'disabled': form.attach_file.length > 4 }"
											@click="add_file_click()"><span class="icon_filebtn"></span>첨부파일 업로드</div>
									</div>

								</div>
							</div>
						</div>
					</div>

					<button type="button" class="btn_style1 aiorderInput_saveBtn" style="display:block;"
						@click="form_aiorder_update_submit()">저장</button>

				</form>
			</div>
		</div>
	</section>

</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import * as aiorderjs from '@/components/utils/aiorder';
import aiorder_template from '@/components/layout/aiorder_template';

const route = useRoute();
const router = useRouter();

const props = defineProps({
	id: {
		type: Number,
		required: true
	},
});

const other_id = ref('');

const today = moment().format('YYYY-MM-DD');

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

// 객체를 배열로 변환하는 함수
function convertObjectToArray(obj) {
	let arrayData = [];
	if (obj && typeof obj === 'object') {
		const prosthesisCount = parseInt(obj.prosthesis_cnt, 10) || 0; // 기본값 0 설정
		for (let i = 1; i <= prosthesisCount; i++) {
			arrayData.push({
				options: obj[`options_${i}`] || '',
				detail: obj[`detail_${i}`] || '',
				details: Array.isArray(obj[`details_${i}`]) ? [...obj[`details_${i}`]] : [], // 깊은 복사
				remake: obj[`remake_${i}`],
				memo: obj[`memo_${i}`] || '',
				teeth: Array.isArray(obj[`teeth_${i}`])
					? obj[`teeth_${i}`].reduce((acc, t) => {
						// 각 배열 요소에 대해 쉼표로 분리하고 공백 제거 후 acc에 추가
						return acc.concat(t.split(',').map(tooth => tooth.trim()));
					}, [])
					: (typeof obj[`teeth_${i}`] === 'string'
						? obj[`teeth_${i}`].split(',').map(t => t.trim()) // 문자열일 경우 쉼표로 분리하고 공백 제거
						: []), // 그 외에는 빈 배열
			});
		}
	}
	return arrayData; // 반드시 배열을 반환
}

const items = ref([]);
const orderJsonData = ref({
	prosthesis_cnt: 0, // 초기에 개수를 0으로 설정
	options_1: '',
	detail_1: '',
	details_1: [],
	remake_1: false,
	memo_1: '',
	teeth_1: [] // 여기가 빈 배열로 초기화됨
});

// 배열 데이터를 자식 컴포넌트에 전달
//const arrayData = ref(convertObjectToArray(orderJsonData.value));
const arrayData = ref([]);
//console.log('Initial arrayData:', arrayData.value); // 초기 데이터 확인

// arrayData의 변경을 감시하고 prosthesis_cnt를 업데이트
watch(arrayData, (newVal) => {
	if (Array.isArray(newVal)) {
		form.value.prosthesis_cnt = newVal.length;

		const remakeCount = newVal.filter(item => item.remake === 'remake').length;
		form.value.remake_cnt = remakeCount;

		// 배열 데이터를 객체로 변환
		const updatedOrderJsonData = {
			prosthesis_cnt: newVal.length,
			remake_cnt: remakeCount,
			...newVal.reduce((acc, item, index) => {
				acc[`options_${index + 1}`] = item.options;
				acc[`detail_${index + 1}`] = item.detail;
				acc[`details_${index + 1}`] = item.details.length ? item.details : []; // 빈 배열 처리
				acc[`remake_${index + 1}`] = item.remake;
				acc[`memo_${index + 1}`] = item.memo;
				acc[`teeth_${index + 1}`] = item.teeth.filter(Boolean); // 빈 값을 제거하여 teeth 배열을 업데이트
				return acc;
			}, {}),
		};

		orderJsonData.value = updatedOrderJsonData; // 업데이트된 데이터를 반영
	}
}, { deep: true });

//console.log('arrayData in parent:', arrayData.value);
//console.log('isArray:', Array.isArray(arrayData.value));  // true여야 정상입니다.

const preview = ref(null);

// fileInput을 참조하기 위한 ref
const fileInput = ref(null);

const form = ref({
	prosthesis_cnt: 0,
	remake_cnt: 0,
	request_doc: null,
	attach_file: [],
	patientName: '',
	patientAge: 0,
	patientGender: '',
	infection: '',
	hospitalName: '',
	hospitalName2: '',
	chartNum: '',
	labName: '',
	chartDate: '',
	registerDate: today,
	completeHopeDate: '',
	scan: '',
	prosthesis1: 0,
	prosthesis2: 0,
	prosthesis3: 0,
	prosthesis4: 0,
	prosthesis5: 0,
	prosthesis6: 0,
	prosthesis7: 0,
	prosthesis8: 0,
	prosthesis9: 0,
	prosthesis10: 0,
	order_status: 'status1',
	deleted_file_id: [], // 배열로 변경
	source: '', // 240919 보철물이 기본인지 치과별인지
});

// 이벤트 핸들러 함수 정의
function handleMaxLengthCheck(event) {
	maxLengthCheck(event, form); // `form`이 `ref`로 전달됨
}

function handleValueCheck(event) {
	valueCheck(event, form); // `form`이 `ref`로 전달됨
}

// `maxLengthCheck` 함수 정의
function maxLengthCheck(event, dataObjectRef) {
	const object = event.target;

	if (typeof dataObjectRef.value === 'undefined') {
		console.debug('Invalid data object reference provided.');
		return;
	}

	// 나머지 함수 로직...
	const modelName = object.id;
	if (!modelName) {
		console.debug('Input element does not have an id attribute.');
		return;
	}

	// 숫자만 허용하는 경우, 숫자가 아닌 문자 제거
	if (object.dataset.type === 'number') {
		object.value = object.value.replace(/\D/g, '');
	}

	// maxLength 제한이 있는 경우, 입력 길이를 제한
	if (object.maxLength) {
		if (object.value.length > object.maxLength) {
			object.value = object.value.slice(0, object.maxLength);
		}
	}

	// `modelName`이 `dataObjectRef.value`에 있는지 확인
	try {
		if (modelName in dataObjectRef.value) {
			dataObjectRef.value[modelName] = object.value; // 데이터 모델 업데이트
			// console.log(`Updated ${modelName} in data object:`, dataObjectRef.value[modelName]);
		} else {
			console.debug(`Model '${modelName}' not found in data object.`);
		}
	} catch (error) {
		console.error('Error updating data model:', error);
	}
}

function valueCheck(event, dataObjectRef) {
	const object = event.target;

	// 디버깅: 전달된 객체가 무엇인지 콘솔에 출력
	console.log('Received dataObjectRef:', dataObjectRef);

	// `dataObjectRef.value`가 유효한지 확인
	if (typeof dataObjectRef.value === 'undefined') {
		console.debug('Invalid data object reference provided.');
		return;
	}

	// `id` 속성을 사용하여 데이터 모델 속성 이름을 추론
	const modelName = object.id;
	if (!modelName) {
		console.debug('Input element does not have an id attribute.');
		return;
	}

	// 입력 값이 비어 있는 경우 0으로 설정
	let newValue = object.value.trim();
	if (newValue.length < 1) {
		newValue = '0';
	} else {
		// 숫자 변환: 앞의 불필요한 0을 제거
		newValue = parseInt(newValue, 10).toString();
	}

	// DOM 업데이트
	object.value = newValue;

	// Vue 데이터 모델 업데이트
	if (modelName in dataObjectRef.value) {
		dataObjectRef.value[modelName] = newValue;
		// console.log(`Updated ${modelName} in data object:`, dataObjectRef.value[modelName]);
	} else {
		console.debug(`Model '${modelName}' not found in data object.`);
	}
}

const updateRemakeCount = (count) => {
	form.value.remake_cnt = count;
};

const updateSource = (source) => {
	form.value.source = source;
};

let OCR_loaded = true;

const aiorder_id = ref(props.id);
watch(
	() => props.id,
	(newVal) => {
		aiorder_id.value = newVal;
	}
);

const prosthesis_sum = ref(0);

const partner = ref([]); // 선택한 상대편 정보

let other_type = ref(null);
let hos_id = ref(null);
let lab_id = ref(null);
if (globaljs.acc_type === 'lab') {
	other_type.value = "치과";
} else {
	other_type.value = "기공소";
}

const goto_url = (url) => {
	router.push(url);
}

const add_doc_click = () => {
	document.getElementById('request_doc').click();
}

// 파일 ID를 삭제 목록에 추가하는 함수
const addDeletedFileId = (file_Id) => {
	if (!form.value.deleted_file_id.includes(file_Id)) {
		form.value.deleted_file_id.push(file_Id);
	}
};

let previousFileName = '';
let uploadComplete = false;
const addDoc = (e) => {
	let file = e.target.files[0];
	// 파일이 선택되지 않은 경우
	if (!file) {
		// 파일이 선택되지 않은 경우에도 이전 파일 이름을 유지
		e.target.value = null;
		e.target.previousFileName = previousFileName; // 유지할 파일 이름 설정
		return;
	}

	let reader = new FileReader();
	let limit = 1024 * 1024 * 3; // 3MB 제한
	let validTypes = ['image/png', 'image/jpeg']; // 허용되는 파일 타입

	// 파일 용량 체크
	if (file.size > limit) {
		commonjs.uploadSwal('size');
		return false;
	}

	// 파일 타입 체크
	if (!validTypes.includes(file.type)) {
		commonjs.uploadSwal('ext');
		return false;
	}

	form.value.request_doc = file;

	// 파일 이름 저장
	previousFileName = file.name;

	document.getElementById('request_doc').closest('.ai_uploadBtnWrap').classList.add('disabled');

	reader.onloadend = () => {
		preview.value = reader.result;
		uploadComplete = true;  // 파일 읽기 완료 시점 설정
	};

	// 파일 읽기 에러 처리
	reader.onerror = () => {
		commonjs.formSwal('파일 읽기 오류', '파일을 읽는 중 오류가 발생했습니다.', '#request_doc', 'self');
	};

	reader.readAsDataURL(file);
};

const removeDoc = (event) => {
	if (event !== undefined) {
		const target = event.target;
		const file_Id = target.getAttribute('data-file_id');

		addDeletedFileId(file_Id); // 파일 ID 추가
	}

	OCR_loaded = false;
	form.value.request_doc = null;
	preview.value = null;
	form.value.patientName = '';
	form.value.patientAge = 0;
	form.value.patientGender = '';
	form.value.infection = '';
	form.value.hospitalName2 = '';
	form.value.chartNum = '';
	form.value.chartDate = '';
	form.value.registerDate = today;
	form.value.completeHopeDate = '';


	const requestDocInput = document.getElementById('request_doc');
	// 파일 입력 필드를 잠시 다른 값으로 설정
	requestDocInput.value = '';
	requestDocInput.type = ''; // 타입을 제거
	requestDocInput.type = 'file'; // 다시 파일로 설정
	document.getElementById('request_doc').closest('.ai_uploadBtnWrap').classList.remove('disabled');

	// 파일 이름 초기화
	previousFileName = '';
};

const get_OCR_order = async (file) => {
	// const api_url = "/naver_ocr/custom/v1/33806/51401d9171312ab8267e55a21e526f89261eb76b72eda4afdc4cc6eb484250cd/infer";
  const api_url = "/naver_ocr/custom/v1/27112/3d8a00c0abf2f3ddaabe993ff8c0171a3c50ff6dbfd3e1ad88a27df7af03fbc4/infer";
	// const SECRET_KEY = "Z05MaXRVQkdsTlBxYlhOb0RkTFdnak1GZ3lGWXJ6T0Q=";
  const SECRET_KEY = "eEdOS1JsQWdjb3ZuV2lTWHRmdlJXSnBWbW55T0FvVUY=";

	// const TEMPLATE = ['31777']; // 기공의뢰서
  const TEMPLATE = ['27550']; // 기공의뢰서

	const api_headers = {
		"Content-Type": "application/json",
		"X-OCR-SECRET": SECRET_KEY,
	};

	const timestamp = Date.now(); // 현재 타임스탬프를 사용합니다
	const data = {
		images: [
			{
				format: "jpg",
				name: "wetree",
				data: file,
				templateIds: TEMPLATE
				//url: "http://dentalcloud.kr/data/order/f8eb7e5de2f5077b7c80f8c6a57d9840.jpg",
			}
		],
		lang: "ko",
		requestId: "guide-json-demo",
		timestamp: timestamp,
		version: "V2"
	};

	const loadingElement = document.getElementById('ocr_loading');

	try {
		loadingElement.style.display = 'block'; // 로딩바 표시
		const response = await axios.post(api_url, data, {
			headers: api_headers
		});

console.debug('get_OCR_order().response', response);
		if (response.data?.images) {
			if( response.data?.images[0].inferResult === "SUCCESS") {
				const fields = response.data.images[0].fields;

				const ymArray = ['년', '월'];
				const oneArray = [',', '/', '[', ']', 'I', 'i', 'l', '|'];
				const menArray = ['남성', '남자', '남', '男', 'male', 'men'];
				const womanArray = ['여성', '여자', '여', '女', 'female', 'woman'];

				form.value.patientName = fields[0].inferText || form.value.patientName;

				if (fields[1].inferText !== '세') { // 나이
					let patientAge = fields[1].inferText.replace(/\s+/g, '');
					patientAge = patientAge.replace('세', '').replace('만', '');
					oneArray.forEach(item => {
						patientAge = patientAge.replace(item, '1');
					});
					form.value.patientAge = patientAge;
				}

				if (fields[2].inferText) { // 성별
					let patientGender = fields[2].inferText.replace(/\s+/g, '');
					menArray.forEach(item => {
						patientGender = patientGender.replace(item, '남');
					});
					womanArray.forEach(item => {
						patientGender = patientGender.replace(item, '여');
					});
					form.value.patientGender = patientGender;
				}

				form.value.chartNum = fields[3].inferText.replace(/\s+/g, ''); // 차트번호

				form.value.hospitalName2 = fields[6].inferText ? fields[6].inferText.replace('Pr', 'Dr') : form.value.hospitalName2; // 담당자

				if (fields[7].inferText !== '년 월 일' && fields[7].inferText.includes('년') && fields[7].inferText.includes('월') && fields[7].inferText.includes('일')) { // 차트접수일
					let chartDate = fields[7].inferText.replace(/\s+/g, '');
					let yearNum = chartDate.slice(0, chartDate.indexOf('년'));
					let yearLen = yearNum.length;
					if (yearLen === 4) {
						// Do nothing
					} else if (yearLen === 0) {
						chartDate = `${new Date().getFullYear()}${chartDate}`;
					} else if (yearLen === 2) {
						chartDate = `${parseInt(new Date().getFullYear().toString().slice(0, 2))}${chartDate}`;
					} else {
						chartDate = chartDate.replace(yearNum, new Date().getFullYear().toString());
					}
					chartDate = chartDate.replace(/년|월/g, '-').replace('일', '');
					oneArray.forEach(item => {
						chartDate = chartDate.replace(item, '1');
					});
					chartDate = chartDate.replace(/[^0-9\-]/g, '');
					form.value.chartDate = commonjs.dateFormatYMD(chartDate, true); // 차트접수일
				}

				if (fields[8].inferText !== '년 월 일' && fields[8].inferText.includes('년') && fields[8].inferText.includes('월') && fields[8].inferText.includes('일')) { // 희망완료일
					let completeHopeDate = fields[8].inferText.replace(/\s+/g, '');
					let yearNum = completeHopeDate.slice(0, completeHopeDate.indexOf('년'));
					let yearLen = yearNum.length;
					if (yearLen === 4) {
						// Do nothing
					} else if (yearLen === 0) {
						completeHopeDate = `${new Date().getFullYear()}${completeHopeDate}`;
					} else if (yearLen === 2) {
						completeHopeDate = `${parseInt(new Date().getFullYear().toString().slice(0, 2))}${completeHopeDate}`;
					} else {
						completeHopeDate = completeHopeDate.replace(yearNum, new Date().getFullYear().toString());
					}
					completeHopeDate = completeHopeDate.replace(/년|월/g, '-').replace('일', '');
					oneArray.forEach(item => {
						completeHopeDate = completeHopeDate.replace(item, '1');
					});
					completeHopeDate = completeHopeDate.replace(/[^0-9\-]/g, '');
					form.value.completeHopeDate = commonjs.dateFormatYMD(completeHopeDate);
				}

				form.value.registerDate = commonjs.dateFormatYMD(form.value.registerDate, true); // 주문일

				for (let i = 10; i <= 19; i++) { // 발송물품 숫자 처리
					if (fields[i].inferText) {
						let prosthesis = fields[i].inferText.replace(/\s+/g, '');
						oneArray.forEach(item => {
							prosthesis = prosthesis.replace(item, '1');
						});
						data.value[`prosthesis${i - 9}`] = isNaN(parseInt(prosthesis)) ? '' : prosthesis;
					}
				}

				OCR_loaded = true;
			} else {
				commonjs.formSwal('기공의뢰서 OCR 오류', '기공의뢰서 인식 오류입니다.', '#request_doc', 'self');
				removeDoc();
			}
		} else {
			commonjs.formSwal('기공의뢰서 OCR 오류', '기공의뢰서 양식에 맞지 않는 이미지입니다.', '#request_doc', 'self');
			removeDoc();
		}

	} catch (error) {
console.error('get_OCR_business()', error);
		commonjs.formSwal('기공의뢰서 OCR 오류', '기공의뢰서 OCR 요청 중 오류가 발생했습니다.', '#request_doc', 'self');
		removeDoc();
	} finally {
		loadingElement.style.display = 'none'; // 로딩바 숨기기
	}
}

const add_file_click = () => {
	document.getElementById('attach_file').click();
}

const addFile = (e) => {
	const fileList = Array.from(e.target.files);
	console.debug("addFile().fileList", fileList);

	if (!fileList || fileList.length === 0) {
		return;
	}

	// 파일 첨부 가능한 최대 용량 (3MB)
	let limit = 1024 * 1024 * 3;
	let validTypes = ['image/png', 'image/jpeg', 'image/gif', 'application/pdf'];

	// 각 파일에 대해 검사
	for (let file of fileList) {
		// 파일 용량 체크
		if (file.size > limit) {
			commonjs.uploadSwal('size');
			return false;
		}

		// 파일 타입 체크
		if (!validTypes.includes(file.type)) {
			commonjs.uploadSwal('ext');
			return false;
		}
	}

	const newFiles = form.value.attach_file.concat(fileList);
	console.debug("addFile().newFiles", newFiles);

	if (newFiles.length > 5) {
		commonjs.formSwal('첨부파일 업로드 오류', '최대 5개 파일만 첨부할 수 있습니다.', '#attach_file', 'self');
		return;
	} else if (newFiles.length === 5) {
		document.getElementById('attach_file').closest('.ai_uploadBtnWrap').classList.add('disabled');
	}

	form.value.attach_file = newFiles;

	// 파일 입력 요소 초기화
	fileInput.value.value = null;
};

const removeFile = (event, index) => {
	if (event !== undefined) {
		const target = event.target;
		const file_Id = target.getAttribute('data-file_id');

		addDeletedFileId(file_Id); // 파일 ID 추가
	}

	form.value.attach_file.splice(index, 1);
	if (form.value.attach_file.length < 5) {
		document.getElementById('attach_file').closest('.ai_uploadBtnWrap').classList.remove('disabled');
	}
};

watch(
	() => preview.value,
	(nVal, oVal) => {
		if (nVal === undefined || nVal === null) {
			return;
		} else {
			if(uploadComplete && nVal) {
				if (nVal != oVal && nVal.includes('base64') && (nVal.includes('image/png') || nVal.includes('image/jpeg'))) {
//console.log(nVal.split('base64,')[1]);
					get_OCR_order(nVal.split('base64,')[1]);
				}
			}
		}
	}, {
		immediate: false // 컴포넌트가 마운트될 때 즉시 실행
	}
)

const clientIP = ref(null);

onMounted(async () => {
	commonjs.DOMLoaded(); // 240724 헤더가 없는 페이지는 불러와야됨
	clientIP.value = await commonjs.getIpAddress();

	await getModels();
});

const getOther = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('other_id', other_id.value);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);
//console.debug('getOrder other_id :', other_id.value);
	try {
		let response = await axios.get(`${SERVER_URL}/api/app/member/other`, { params });
//console.debug(response.data.result);
		if (response.data.result?.length > 0) {
			partner.value = response.data.result[0];
		}
	} catch (error) {
console.error('Error getOther:', error);
	}
}

const getModels = async () => {
	if (isNaN(props.id)) {
		commonjs.formSwal('정보 없음', '주문서 정보를 가져오지 못했습니다. URL를 다시 한번 확인해 주세요.');
	} else {
		try {
			let response = await axios.get(`${SERVER_URL}/api/app/aiorder/${props.id}`);
console.debug(response.data.result);
			items.value = response.data.result;
			if (!((items.value.order_status === 'ords1' && globaljs.acc_type === 'hospital') || ((items.value.order_status === 'ords1' || items.value.order_status === 'ords2') && (globaljs.acc_type === 'lab')))) {
				commonjs.formSwal('권한 없음', '수정할 권한이 없습니다.', 'popup', 'error');
			}
			// 241022 파싱할때 특수문자 오류. sanitizeJSONString함수 추가.
			const sanitizedData = commonjs.sanitizeJSONString(items.value.order_json_data);
console.debug(JSON.parse(sanitizedData));
			orderJsonData.value = JSON.parse(sanitizedData); // 기존 데이터 가져오기

			other_id.value = (globaljs.acc_type === 'lab') ? items.value.hospital_mb_id : items.value.lab_mb_id;
console.debug('other_id: ', other_id.value);
			await getOther();

			for (let i = 1; i <= 10; i++) {
				if (typeof orderJsonData.value[`prosthesis${i}`] !== 'undefined') {
console.debug(`prosthesis${i}`, parseInt(orderJsonData.value[`prosthesis${i}`]) );
					prosthesis_sum.value += isNaN(parseInt(orderJsonData.value[`prosthesis${i}`])) ? 0 : parseInt(orderJsonData.value[`prosthesis${i}`]);
					form.value[`prosthesis${i}`] = isNaN(parseInt(orderJsonData.value[`prosthesis${i}`])) ? 0 : parseInt(orderJsonData.value[`prosthesis${i}`]);
				} else {
					form.value[`prosthesis${i}`] = 0;
				}
			}

			form.value.prosthesis_cnt = orderJsonData.value.prosthesis_cnt;
			form.value.remake_cnt = parseInt(items.value.remake_cnt, 10);
			form.value.order_status = items.value.order_status;
			form.value.lab_memo = items.value.lab_memo;

			form.value.request_doc = items.value.aiorderAiorderDoc[0];
			form.value.attach_file = items.value.aiorderAiorderFile;
			form.value.patientName = orderJsonData.value.patientName;
			form.value.patientAge = orderJsonData.value.patientAge;
			form.value.patientGender = orderJsonData.value.patientGender;
			form.value.infection = orderJsonData.value.infection;
			form.value.hospitalName = orderJsonData.value.hospitalName;
			form.value.hospitalName2 = orderJsonData.value.hospitalName2;
			form.value.chartNum = orderJsonData.value.chartNum;
			form.value.labName = orderJsonData.value.labName;
			form.value.chartDate = orderJsonData.value.chartDate;
			form.value.registerDate = orderJsonData.value.registerDate;
			form.value.completeHopeDate = orderJsonData.value.completeHopeDate;
			form.value.scan = orderJsonData.value.scan;

			arrayData.value = convertObjectToArray(orderJsonData.value); // 가져온 데이터를 배열로 변환
console.log('arrayData:: ', arrayData.value);
			//templates.value = orderJsonData.value;

		} catch (error) {
	//console.error('Error getModels:', error);
		}
	}
}

async function form_aiorder_update_submit() {
	await withSubmitFlag(async () => {
		const formData = new FormData();
		formData.append('mb_id', globaljs.mb_id);
		formData.append('acc_type', globaljs.acc_type);
		formData.append('mb_level', globaljs.mb_level);

		const formElement = document.getElementById('form_aiorder_update');

		if(commonjs.is_null(form.value.request_doc) || form.value.request_doc === null) {
			commonjs.formSwal(`의뢰서 파일 업로드 필수`, `[의뢰서 파일]은 필수 입력 항목입니다.`, `#request_doc`, 'self');
			return false;
		}

		const essentials = formElement.querySelectorAll('[required]');
		for (const element of essentials) {
			if (!element.value) {
				const label = formElement.querySelector(`label[for="${element.id}"]`);
				const fieldName = label ? label.textContent.replace(':', '') : element.name;
				commonjs.formSwal(`필수 입력`, `[${fieldName}]은 필수 입력 항목입니다.`, `#${element.id}`, 'self');
				return false;
			}

			// input type="date"의 경우 날짜 형식 검증
			if (element.type === 'date' && !commonjs.isValidDate(element.value)) {
				const label = formElement.querySelector(`label[for="${element.id}"]`);
				const fieldName = label ? label.textContent.replace(':', '') : element.name;
				commonjs.formSwal(`날짜 형식 오류`, `[${fieldName}]의 날짜 형식이 올바르지 않습니다.`, `#${element.id}`, 'self');
				return false;
			}
		}

		formElement.querySelectorAll('input').forEach((input) => {
			if (input.type === 'checkbox' && input.id !== 'chk_all' && input.name !== "") {
				if (input.checked) {
					if (!formData.has(input.name)) {
						formData.append(input.name, input.value);
					} else {
						const existingValue = formData.get(input.name);
						formData.set(input.name, `${existingValue},${input.value}`);
					}
				}
			} else if (input.type === 'radio' && input.name !== "") {
				if (input.checked) {
					formData.append(input.name, input.value);
				}
			} else if (input.name) { // input.name이 존재하는 경우에만 추가
				formData.append(input.name, input.value);
			}
		});

		formElement.querySelectorAll('select').forEach((select) => {
			if (select.name) { // select.name이 존재하는 경우에만 추가
				formData.append(select.name, select.value);
			}
		});

		formElement.querySelectorAll('textarea').forEach((textarea) => {
			if (textarea.name) { // textarea.name이 존재하는 경우에만 추가
				formData.append(textarea.name, textarea.value);
			}
		});

		// form 객체에서 데이터를 가져와 FormData에 추가
		for (let i = 1; i <= 10; i++) {
			const key = `prosthesis${i}`;
			//if (form.value[key] !== 0) { // 기본값 0이 아닌 경우에만 추가
			// 241002 0이라도 추가하게
			formData.append(key, form.value[key]);
			//}
		}

		// 240826 의뢰서 확인일때는 보철물 필수
		if (items.value.order_status === 'ords2' && parseInt(form.value.prosthesis_cnt, 10) < 1) {
			commonjs.formSwal(`필수 입력`, `의뢰내용(보철물) 정보가 없습니다. 추가해서 작성해 주세요.`, `.plusBtn`, `self`);
		}

		// 추가적으로 v-model로 바인딩된 값들 명시적으로 추가
		formData.append('prosthesis_cnt', form.value.prosthesis_cnt);

		if (parseInt(form.value.prosthesis_cnt, 10) > 0) {
			for (let i=1; i<=form.value.prosthesis_cnt; i++) {
				if ( orderJsonData.value[`options_${i}`] === '') {
					commonjs.formSwal(`필수 입력`, `${i}번째의 의뢰내용에서 보철물을 선택해 주세요.`, `#options_${i}`, `self`);
					return false;
				}
				if ( orderJsonData.value[`detail_${i}`] === '') {
					commonjs.formSwal(`필수 입력`, `${i}번째의 의뢰내용에서 보철물 상세를 선택해 주세요.`, `#detail_${i}`, `self`);
					return false;
				}

				const teethElements = formElement.querySelectorAll(`input[name="teeth_${i}[]"]`);
				//console.log( teethElements );
				// Check if at least one of the teeth checkboxes is checked
				let atLeastOneChecked = false;
				for (const element of teethElements) {
					if (element.checked) {
						atLeastOneChecked = true;
						break;
					}
				}

				if (!atLeastOneChecked) {
					commonjs.formSwal(`필수 입력`, `${i}번째의 의뢰내용에서 최소 하나의 치아를 선택해 주세요.`, `#options_${i}`, `self`);
					return false;
				}
			}
		}

		formData.append('remake_cnt', form.value.remake_cnt);
		formData.append('source', form.value.source);
		formData.append('patientName', form.value.patientName);
		formData.append('patientAge', form.value.patientAge);
		formData.append('patientGender', form.value.patientGender);
		formData.append('infection', form.value.infection);
		formData.append('hospitalName', form.value.hospitalName);
		formData.append('hospitalName2', form.value.hospitalName2);
		formData.append('chartNum', form.value.chartNum);
		formData.append('labName', form.value.labName);
		formData.append('chartDate', form.value.chartDate);
		formData.append('registerDate', form.value.registerDate);
		formData.append('completeHopeDate', form.value.completeHopeDate);
		formData.append('scan', form.value.scan);
		// 서버로 전송하기 전에 배열을 문자열로 변환
		formData.append('deleted_file_id', form.value.deleted_file_id.join(','));

		if (form.value.request_doc) {
			formData.append("request_doc", form.value.request_doc);
		}

		if (form.value.attach_file.length > 0) {
			form.value.attach_file.forEach((file, index) => {
				formData.append(`attach_file_${index + 1}`, file);
			});
		}

		// URLSearchParams를 객체로 변환
		const object = {};
		formData.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		const config = {
			headers: {
				"Content-Type": "multipart/form-data"
			},
		};

		try {
			const response = await axios.put(`${SERVER_URL}/api/app/aiorder`, formData, config);
	console.debug(response.data.result);
			commonjs.formSwal('수정 완료', 'AI 기공주문서를 수정했습니다.', 'popup');
			Swal.fire({
				title: '수정 완료',
				text: 'AI 기공주문서를 수정했습니다.',
				icon: 'success',
				confirmButtonText: '확인',
				allowOutsideClick: false,  // 외부 클릭 방지
				allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
				returnFocus: false,
			}).then(async (result) => {
				if (result.isConfirmed) {
					await router.push(`/aiorder_view/${aiorder_id.value}`);
				}
			});
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>
<style>
/* 로딩바 스타일 */
#ocr_loading {
	display: none;
	/* 초기에는 숨김 */
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.5);
	/* 배경 투명도 */
	z-index: 9999;
	text-align: center;
	color: white;
	font-size: 30px;
	padding-top: 20%;
}
</style>
